import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone } from '../utils'
import Loading from './Loading'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';

function ExtractMetaTags({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()


    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };

            setIsLoading(true)
              fetch(`${base}/res`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'emt',
                  url: url,
                  userId: user.id
                })
              }).then(res=> res.json()).then(data=> {
                setData([data])
                setIsLoading(false)
                dispatch(redNex(nx))
                updateAnalytics()
              })
            } else {
              if(url.trim() === '') setNoInput1(true)
            }
    }



  return (
    <ExtractMetaTagsContainer>
            <ExtractMetaTagsInputContainer>
            <h2>Extract Meta Tags <span style={{fontSize: 'medium'}}></span></h2>
            <ExtractMetaTagsInnerInputContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </ExtractMetaTagsInnerInputContainer>
        </ExtractMetaTagsInputContainer>

        {data.length !== 0 && !isLoading && <ExtractMetaTagsResContainer>
            <ExtractMetaTagsRes style={{fontWeight: '400'}}>
                <p style={{width: '120px'}}>Name</p>
                <p style={{width: '350px'}}>Content</p>
                <p style={{width: '160px'}}>Used By Google</p>
                <p style={{width: '160px', marginRight: '25px'}}>Used By Bing</p>
            </ExtractMetaTagsRes>

            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            {data[0]?.map(m=> {
                return (
                    <ExtractMetaTagsRes>
                                        <p style={{width: '120px'}}>{m.name}</p>
                                        <p style={{width: '350px'}}>{m.content}</p>
                                        <p style={{width: '160px'}}>{m.usedByGoogle.toLowerCase() === 'yes'? <CheckBoxIcon style={{color: 'rgb(16, 208, 16)'}} />: <DisabledByDefaultIcon style={{color: 'red'}} />}</p>
                                        <p style={{width: '160px'}}>{m.usedByBing.toLowerCase() === 'yes'? <CheckBoxIcon style={{color: 'rgb(16, 208, 16)'}} />: <DisabledByDefaultIcon style={{color: 'red'}} />}</p>
                    </ExtractMetaTagsRes>
                )
            })}</div>
        </ExtractMetaTagsResContainer>}

        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Extract Meta Tags Tool retrieves and displays the meta tags from a webpage, 
            including the title, description, keywords, and other relevant metadata. 
            This helps you quickly analyze the meta information used on any page for SEO purposes.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of the page from which you want to extract meta tags</p>
          <p>2. Click "Get Data" to retrieve and view the meta tags</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Ensure that your meta tags are well-optimized with relevant keywords and compelling descriptions to improve your search engine rankings</p>

        </Intro>}
    </ExtractMetaTagsContainer>
  )
}

export default ExtractMetaTags


const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const ExtractMetaTagsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`


const ExtractMetaTagsInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--cntnt-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--cntnt-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--cntnt-color);
    color: white;
  }

  > div > button:hover {
    color: var(--cntnt-color);
    background-color: rgb(239, 239, 239);
  }
`


const ExtractMetaTagsInnerInputContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--cntnt-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const ExtractMetaTagsResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const ExtractMetaTagsRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`